<template>
	<section class="form-group FormToggle" :data-entry="id || name">
		<label v-if="label" class="title" :for="id || name" :class="{ required }">{{ label }}</label>
		<div class="input-area">
			<label :for="`${formId}_${id || name}`" :class="{ checked: value }"></label>
			<input class="input" :id="`${formId}_${id || name}`" v-bind="$attrs" :value="value" @change="toggle()" type="checkbox" :checked="value" />
		</div>
	</section>
</template>

<script>
import mixin from './mixin';
export default {
	mixins: [mixin],
	props: {
		options: Array,
	},
	methods: {
		toggle() {
			this.$emit('change', !this.value);
		},
	},
};
</script>

<style scoped lang="scss">
.FormToggle {
	.input-area {
		display: flex;
		align-items: center;

		label {
			display: inline-block;
			width: 6.4rem !important;
			height: 2.6rem;
			position: relative;
			cursor: pointer;
			border-radius: 4rem;
			background-color: #ddd;

			&::after {
				content: '';
				display: block;
				width: calc(2.4rem);
				height: calc(2.4rem);
				background-color: white;
				border-radius: 2.4rem;
				position: absolute;
				left: 0.1rem;
				top: 0.1rem;
				transition: all 0.2s;
				white-space: nowrap;
			}

			&::before {
				content: 'OFF';
				display: inline-block;
				position: absolute;
				left: calc(100% - 1rem);
				top: 50%;
				transform: translate(-100%, -50%);
				transition: all 0.2s;
				font-size: 1.2rem;
				white-space: nowrap;
			}

			&.checked {
				background-color: var(--color);

				&::after {
					left: calc(100% - 0.1rem);
					transform: translateX(-100%);
				}

				&::before {
					content: 'ON';
					left: 1rem;
					transform: translate(0, -50%);
					color: white;
				}
			}
		}

		input {
			display: none;
		}
	}
}
</style>
